import { useMemo } from 'react';
import { CookieUtils } from '@framework/CookieUtils';

const CookieName = 'signUpMode';
const CookieAttributes = { expires: 10 * 60, path: '/' };

const FallbackMode = 'withoutInvitation';
const modeNames = ['withInvitation', 'withoutInvitation'] as const;
export type SignUpMode = (typeof modeNames)[number];

export const getAdjustedSignUpMode = (signUpMode: string | null): SignUpMode => {
  return modeNames.find((mode) => mode === signUpMode) || FallbackMode;
};

export const useStoreSignUpMode = () => {
  return useMemo(() => {
    const store = (mode: SignUpMode) => {
      CookieUtils.set(CookieName, mode, CookieAttributes);
    };

    const fetch = (): SignUpMode => {
      const cookies = document.cookie.split('; ');
      const cookieValue = cookies.find((cookie) => cookie.startsWith(`${CookieName}=`));
      if (!cookieValue) return FallbackMode;

      const value = cookieValue.replace(`${CookieName}=`, '');
      return getAdjustedSignUpMode(value);
    };

    return { store, fetch };
  }, []);
};
